export function formatFileType(fileType: string): string {
  const typeMap: Record<string, string> = {
    image: 'Image',
    video: 'Video',
    audio: 'Audio',
    'application/pdf': 'PDF',
    'application/msword': 'Word Document',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'Word Document',
    'application/vnd.ms-excel': 'Excel Spreadsheet',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'Excel Spreadsheet',
    'application/vnd.ms-powerpoint': 'PowerPoint Presentation',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation':
      'PowerPoint Presentation',
    'text/plain': 'Text File',
    'text/csv': 'CSV',
    'application/zip': 'ZIP Archive',
    'application/x-rar-compressed': 'RAR Archive',
    'application/vnd.oasis.opendocument.text': 'Word Document',
    'application/rtf': 'Rich Text',
    'application/vnd.apple.pages': 'Pages Document',
    'application/vnd.apple.keynote': 'Keynote Presentation',
    'text/html': 'HTML File',
    'text/markdown': 'Markdown File',
    'text/x-markdown': 'Markdown File',
    'application/json': 'JSON File',
    'application/xml': 'XML File',
    'text/xml': 'XML File',
    'text/x-iif': 'IIF File',
    'text/tab-separated-values': 'TSV File',
    'application/vnd.oasis.opendocument.spreadsheet': 'Spreadsheet',
    'text/javascript': 'Code File',
    'text/typescript': 'Code File',
    'text/x-python': 'Code File',
    'text/x-java-source': 'Code File',
    'text/x-csrc': 'Code File',
    'text/x-c++src': 'Code File',
    'text/x-csharp': 'Code File',
    'text/x-ruby': 'Code File',
    'text/x-go': 'Code File',
    'text/x-rust': 'Code File',
    'text/x-swift': 'Code File',
    'text/x-kotlin': 'Code File',
    'text/x-php': 'Code File',
    'text/x-shellscript': 'Code File',
  };

  const category = fileType.split('/')[0];

  return typeMap[fileType] || typeMap[category] || 'Unknown File';
}
